import AdvisoriesMap from 'components/StormCenter/AdvisoriesMap';
import HurricanesTropicalStorms from 'components/StormCenter/HurricanesTropicalStorms';
import NWSAlerts from 'components/StormCenter/NWSAlerts';
import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';
import { usePerms } from 'contexts/PermsContext';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetCWActiveAlertsQuery } from 'services/alerts/alerts.api';
import TabsHeader from '../../components/TabsHeader/TabsHeader';

export default function StormCenter() {
  const [params] = useSearchParams();
  const { data: cwActiveAlerts, isFetching } = useGetCWActiveAlertsQuery();
  const localAlertsSortedByTime = cwActiveAlerts?.result?.sort((a, b) => {
    return new Date(b.sentTime) - new Date(a.sentTime);
  });

  const perms = usePerms();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!(await perms.validatePermissions(['StormCenterEnabled']))) {
        navigate('/404');
        return;
      }
    })();
  }, []);

  const ROUTE = 'NWSandMyForecastAlerts';

  if (isFetching) {
    return <WidgetLoadingAnimation />;
  }

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'nws alerts':
        return (
          <div className="scrollbar-hidden h-100 overflow-auto">
            <WidgetTimeUpdate route={ROUTE} realtime dataUpdateOnly />
            <NWSAlerts title="Current NWS Alerts" />
          </div>
        );
      case 'my forecast advisories':
        return (
          <div className="scrollbar-hidden h-100 overflow-auto">
            <WidgetTimeUpdate route={ROUTE} realtime dataUpdateOnly />
            <NWSAlerts localAlerts={localAlertsSortedByTime} title="My Forecast Advisories" />
          </div>
        );
      case 'advisories map':
        return <AdvisoriesMap />;
      case 'hurricanes and tropical storms':
        return <HurricanesTropicalStorms />;
      default:
        return (
          <div className="scrollbar-hidden h-100 overflow-auto">
            <WidgetTimeUpdate route={ROUTE} realtime dataUpdateOnly />
            <NWSAlerts title="Current NWS Alerts" />
          </div>
        );
    }
  };

  return (
    <Container fluid className="d-flex flex-column h-100 py-3">
      {/* header */}
      <div className="d-none d-lg-block">
        <TabsHeader
          options={[
            { option: 'NWS Alerts' },
            { option: 'My Forecast Advisories' },
            { option: 'Advisories Map' },
            { option: 'Hurricanes and Tropical Storms' },
          ]}
          styles={[{ backgroundColor: '#436c98' }]}
        />
      </div>
      <div className="d-block d-lg-none">
        <MobileTabsHeader
          options={[
            { option: 'NWS Alerts' },
            { option: 'My Forecast Advisories' },
            { option: 'Advisories Map' },
            { option: 'Hurricanes and Tropical Storms' },
          ]}
          styles={[{ backgroundColor: '#436c98' }]}
        />
      </div>
      {renderTab()}
    </Container>
  );
}
